const getBackgroundColorClass = (type) => "bg-".concat(type);
const getColorClass = (type) => "c-".concat(type);
const getGraphicColorClass = (type) => "c-".concat(type);
export {
  getBackgroundColorClass,
  getColorClass,
  getGraphicColorClass
};
